import type { ReadonlyURLSearchParams } from 'next/navigation';

export const getSearchParamsUrlSuffix = (
  searchParams: ReadonlyURLSearchParams | null,
  sku: string,
) => {
  if (searchParams === null) return '';

  if (searchParams.has('sku')) return `?${searchParams.toString()}`;

  return `?sku=${sku}&${searchParams?.toString()}`;
};
